import React from "react";

/**
 * Render a table from a list of rows [{ label, value }]
 * Returns a JSX element for React
 */

const RenderTable = ({ rows }) => (
  <table style={{ width: "100%", borderCollapse: "collapse" }}>
    <tbody>
      {rows && rows.length > 0 ? (
        rows.map((row, i) => (
          <tr
            key={i}
            style={{ backgroundColor: i % 2 === 0 ? "#ffffff" : "#f7f7f7" }}
          >
            <td
              style={{
                padding: "10px",
                fontWeight: "bold",
                width: "200px",
                borderBottom: "1px solid #ddd",
              }}
            >
              {row.label}
            </td>
            <td
              style={{
                padding: "10px",
                borderBottom: "1px solid #ddd",
              }}
            >
              {row.value || "-"}
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={2} style={{ padding: "10px", textAlign: "center" }}>
            No data available
          </td>
        </tr>
      )}
    </tbody>
  </table>
);

export default RenderTable;
